module.exports = __webpack_public_path__ + "static/media/m19.7b4e9601.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/m19.jpg
// module id = 227
// module chunks = 0